export default "__VITE_ASSET__DgbiQoC9__"